import React from 'react';
import './CustomCheckbox.scss';

function CustomCheckbox({ id, checked, onChange, value, disabled = false }) {
    return (
        // <React.Fragment>
        <div className='checkboxArea'>
            <input id={id} className='customCheckbox' type="checkbox" checked={checked} onChange={onChange} value={value} disabled={disabled} />
            <label htmlFor={id} className='customCheckboxLabel'>
                <div className={`labelDiv ${checked ? 'checked' : null} ${disabled ? 'disabled' : null}`} />
            </label>
        </div>
        // </React.Fragment>
    );
}

export default CustomCheckbox;